// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__66Poc","header":"ClearentDisclaimer_header__2t45A","inner":"ClearentDisclaimer_inner__17rfD"};